import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { Login } from './components/login/Index';
import { SessionProvider, useSession } from './hooks/session';
import Home from './components/home/Index';
import { Users } from './components/userManagement/users/Index';
import { UserInquire } from './components/userManagement/users/UserInquire';
import { Dashboard } from './components/dashboard/Index';
import withAuthentication from './components/commonComponent/others/_withAuthentication';
import { EmpAdminister } from './components/empAdminister/Index';
import { AccountManagement } from './components/empAdminister/AccountManagement';
import { LoginHistory } from './components/empAdminister/LoginHistory';
import { Schools } from './components/school/Index';
import { SchoolInquire } from './components/school/SchoolInquire';
import { Books } from './components/book/Index';
import { BookInquire } from './components/book/BookInquire';
import { ClassStat } from './components/classStat/Index';
import { UserStat } from './components/classStat/UserStat';
import { ClassRank } from './components/classStat/ClassRank';
import { ClassStatistics } from './components/classStat/ClassStatistics';
import { SchoolRank } from './components/schoolStat/SchoolRank';
import { SchoolStatistics } from './components/schoolStat/SchoolStatistics';
import { SchoolStat } from './components/schoolStat/Index';
import { EducationOfficeStat } from './components/educationOfficeStat/Index';
import { EducationOfficeRank } from './components/educationOfficeStat/EducationOfficeRank';
import { EducationOfficeStatistics } from './components/educationOfficeStat/EducationOfficeStatistics';
import { PortalStat } from './components/portalStat/Index';
import { PortalSchoolRank } from './components/portalStat/PortalSchoolRank';
import { PortalClassRank } from './components/portalStat/PortalClassRank';
import { PortalStatistics } from './components/portalStat/PortalStatistics';
import { ClassLogManage } from './components/classStat/ClassLogManage';
import { SchoolLogManage } from './components/schoolStat/SchoolLogManage';
import { EducationOfficeLogManage } from './components/educationOfficeStat/EducationOfficeLogManage';
import { PortalLogManage } from './components/portalStat/PortalLogManage';
import { SchoolClassStat } from './components/schoolStat/SchoolClassStat';
import { EducationOfficeSchoolStat } from './components/educationOfficeStat/EducationOfficeSchoolStat';
import { EducationOfficeSchoolRank } from './components/educationOfficeStat/EducationOfficeSchoolRank';
import { PortalEducationOfficeRank } from './components/portalStat/PortalEducationOfficeRank';

declare global {
  interface Window {
    kakao: any;
    naver: any;
  }
}

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginVal, session } = useSession();
  const [param, setParam] = useState<string>('');

  useEffect(() => {
    const newParam = location.pathname.split('/')[1];
    setParam(newParam);
    return () => {
      setParam('');
    };
  }, [location.pathname]);

  return (
    <>
      {loginVal.value?.didLogin ? <Home /> : ''}
      {/* {loginVal.value?.didLogin ? <Home /> : ''} */}
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/' element={<Dashboard />} />
        <Route path='/users' element={<Users />}>
          <Route path='userinquire' element={<UserInquire />} />
        </Route>
        <Route path='/schools' element={<Schools />}>
          <Route path='schoolinquire' element={<SchoolInquire />} />
        </Route>
        <Route path='/books' element={<Books />}>
          <Route path='bookinquire' element={<BookInquire />} />
        </Route>
        <Route path='/classstat' element={<ClassStat />}>
          <Route path='userstat' element={<UserStat />} />
          <Route path='classrank' element={<ClassRank />} />
          <Route path='classstatistics' element={<ClassStatistics />} />
          <Route path='classlogmanage' element={<ClassLogManage />} />
        </Route>
        <Route path='/schoolstat' element={<SchoolStat />}>
          <Route path='classstat' element={<SchoolClassStat />} />
          <Route path='schoolrank' element={<SchoolRank />} />
          <Route path='schoolstatistics' element={<SchoolStatistics />} />
          <Route path='schoollogmanage' element={<SchoolLogManage />} />
        </Route>
        <Route path='/educationofficestat' element={<EducationOfficeStat />}>
          <Route path='schoolstat' element={<EducationOfficeSchoolStat />} />
          <Route path='schoolrank' element={<EducationOfficeSchoolRank />} />
          <Route
            path='educationofficestatistics'
            element={<EducationOfficeStatistics />}
          />
          <Route
            path='educationofficelogmanage'
            element={<EducationOfficeLogManage />}
          />
        </Route>
        <Route path='/portalstat' element={<PortalStat />}>
          <Route path='portalclassrank' element={<PortalClassRank />} />
          <Route path='portalschoolrank' element={<PortalSchoolRank />} />
          <Route
            path='portaleducationofficerank'
            element={<PortalEducationOfficeRank />}
          />
          <Route path='portalstatistics' element={<PortalStatistics />} />
          <Route path='portallogmanage' element={<PortalLogManage />} />
        </Route>
        <Route path='/empadminister' element={<EmpAdminister />}>
          <Route path='accountmanagement' element={<AccountManagement />} />
          <Route path='loginhistory' element={<LoginHistory />} />
        </Route>
      </Routes>
    </>
  );
}

// export default App;
export default withAuthentication(App);
